import { EMPTY_PAGE_ID } from '@webapp/account/src/resources/questions/questions';

import type { Question } from '@webapp/common/resources/entities/question';

import type { States } from '../states';

import type { QuestionsState } from './state';

export const selectQuestions = ({ Questions }: States): QuestionsState => Questions;

export const selectQuestionList = (states: States): Array<Question> => {
    const q = selectQuestions(states);

    return q.items;
};

export const selectPagesWithQuestions = (states: States) => {
    return {
        pages: states.Pages.pages.map((p) => ({
            ...p,
            questions: states.Questions.items.filter((q) => q.pageId === p.id),
        })),
    };
};

export const selectAllForwardLogic = (states: States) => {
    return {
        forwardLogics: states.Questions.items.flatMap((q) => q.forwardLogic ?? []),
    };
};

export const isRandomOrderEnabledForPage = (pageId: number) => (states: States) => {
    const page = states.Pages.pages.find((page) => page.id === pageId);
    if (!page) return false;

    return page.random;
};

export const selectCurrentPageQuestionList = (states: States): Array<Question> => {
    const q = selectQuestionList(states);
    const { activePageId } = states.Pages;

    return q.filter(({ pageId }) => pageId === activePageId || pageId === EMPTY_PAGE_ID);
};

export const selectNoPageQuestions = (states: States): boolean => {
    const qs = selectCurrentPageQuestionList(states);

    return qs.length === 0;
};

export const selectQuestionsLoading = (states: States): boolean => {
    const q = selectQuestions(states);

    return q.fetch;
};

export const selectExpanded = (states: States): boolean => {
    const q = selectQuestions(states);

    return q.expanded;
};

export const selectConfirmRemove = (states: States): boolean => {
    const q = selectQuestions(states);

    return q.confirmRemove;
};

export const selectQuestionById =
    (questionId: number) =>
    ({ Questions: { items } }: States): Question =>
        items.find(({ id }) => id === questionId);

export const selectNearByIds =
    (questionId: number) =>
    (states: States): { before: number; after: number } => {
        const qs = selectQuestionList(states);
        const idx = qs.findIndex(({ id: id }) => id === questionId);
        return {
            before: qs[idx - 1]?.id || null,
            after: qs[idx + 1]?.id || null,
        };
    };

export const getQuestionByAnswerId = (answerId: number | null) => (states: States) => {
    if (!answerId) return null;
    return states.Questions.items.find((q) => q.rows.find((r) => r.id === answerId));
};

export const selectIsAnyOfQuesitonsOnPageHasForwardLogic = (pageId: number | null) => (states: States) => {
    if (!pageId) return false;
    const qIds = states.Questions.items.filter((q) => q.pageId === pageId).map((q) => q.id);
    return states.Questions.items?.some((q) => q.forwardLogic?.some((fl) => qIds.includes(fl.childQuestionId)));
};
